export * from './auth-guard.service';
export * from './aviso.service';
export * from './cartao.service';
export * from './cep.service';
export * from './ci.service';
export * from './css.service';
export * from './download.service';
export * from './http.service';
export * from './login.service';
export * from './loja-carrinho.service';
export * from './loja.service';
export * from './main.service';
export * from './pagamento.service';
export * from './parceiro.service';
export * from './permission.service';
export * from './preloading-strategy.service';
export * from './sac.service';
export * from './saldo.service';
export * from './services.service';
export * from './session-service.service';
export * from './vale-presente-cesta-service.service';
export * from './vale-presente.service';



// WEBPACK FOOTER //
// ./src/app/resources/services/index.ts